import { paymentTypes, sloanAddressBook, sloanCheckout, sloanCheckoutAddress, sloanCheckoutMode } from './checkout';

export const en = {
  sloanCheckout,
  paymentTypes,
  sloanCheckoutAddress,
  sloanAddressBook,
  sloanCheckoutMode,
};
